import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ArchiveDocumentsBoxIcon = createIcon({
  displayName: 'ArchiveDocumentsBoxIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path
        d="M4,12.07421V9.5a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2v2.586"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M5,7.768V5A2,2,0,0,1,7,3H17a2,2,0,0,1,2,2V7.768"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15,15.5v1a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1v-1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4.5,12h15A1.5,1.5,0,0,1,21,13.5V19a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V13.5A1.5,1.5,0,0,1,4.5,12Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const ArchiveDocumentsBox: FC<IconProps> = (props) => {
  return <CustomIcon as={ArchiveDocumentsBoxIcon} {...props} />
}

export default memo(ArchiveDocumentsBox)
